/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */

import { connect } from 'react-redux';
import { SEISMICITY_DESIGN } from '@hbrisk/sp3-risk-model-support/models/app/attributes/names/index.js';
import { modelTypesByForm } from '#src/js/constants/models/modelTypes/index.js';
import PrimaryBuildingInfoSection from './PrimaryBuildingInfoSection.jsx';

const mapStateToProps = (state, ownProps) => {
  const { selectIsCountryJapan, selectFormFieldVisibility } = modelTypesByForm[ownProps.form];
  return {
    isJapan: selectIsCountryJapan(state),
    showSeismicity: selectFormFieldVisibility(state)(SEISMICITY_DESIGN),
  };
};

export default connect(mapStateToProps)(PrimaryBuildingInfoSection);
